import React, { ComponentType, ErrorInfo } from "react";
import { FallbackProps, ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";
import { GrafanaFaro } from "../../../instrumentation/grafanaFaro";

type Props = {
  children: React.ReactNode;
  errorContext?: Record<string, string>;
  FallbackComponent: ComponentType<FallbackProps>;
};

export function ComponentErrorBoundary({ FallbackComponent, children, errorContext }: Props) {
  const logError = (error: Error, info: ErrorInfo) => {
    console.error(error);
    const errorWithStack = getErrorWithComponentStack(error, info);
    GrafanaFaro.reportError(errorWithStack, errorContext ? { context: errorContext } : undefined);
  };

  return (
    <ReactErrorBoundary FallbackComponent={FallbackComponent} onError={logError}>
      {children}
    </ReactErrorBoundary>
  );
}

function getErrorWithComponentStack(error: Error, errorInfo: ErrorInfo): Error {
  const newError = new Error(error.message);
  newError.name = `React ErrorBoundary ${error.name}`;
  newError.stack = errorInfo.componentStack ?? undefined;
  return newError;
}
